<template>
  <div>
  <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
  <v-stepper v-else v-model="stepper">
    <v-stepper-header>
      <v-divider></v-divider>
      <v-stepper-step :complete="stepper > 1" :editable="stepper > 1" step="1">{{ $t("schema.builder.tabs.basic") }}</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="stepper > 2" :editable="stepper > 2" step="2">{{ $t("schema.builder.tabs.form-fields") }}</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>
    <v-stepper-items id="work-block">
      <v-stepper-content step="1">
        <div class="sub-form">
          <basic @validated="basicValid = $event" ></basic>
        </div>
        <v-divider class="tab-step-button-divider"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn large color="primary" :disabled="!basicValid" round @click="stepper++">{{ $t("base.continue") }}</v-btn>
        </v-card-actions>
      </v-stepper-content>
      <v-stepper-content step="2">
        <div class="sub-form">
          <inputs></inputs>
        </div>
        <v-divider class="tab-step-button-divider"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading"
            indeterminate
            style="margin-right: 10px"
            color="primary"
            ></v-progress-circular>
          <v-btn large round @click="stepper--">{{ $t("base.back") }}</v-btn>
          <v-btn large color="primary" round :disabled="loading" @click="submit">{{ $t("base.submit") }}</v-btn>
        </v-card-actions>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
  </div>
</template>

<script>
import basic from './builder/tabs/Basic.vue'
import inputs from './builder/tabs/Inputs.vue'
import final from './builder/tabs/Final.vue'
import http from "@/plugins/http"

export default {
  components: {
    basic,
    inputs,
    final
  },
  data() {
    return {
      basicValid: false,
      stepper: 1,
      loading: false
    }
  },
  computed: {
    isNew() {
      return this.$route.name === 'schema-builder'
    },
    fields() {
      return this.$store.state.schemaBuilder.fields
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$store.commit("setSchemaFieldOrders")
      this.$store.dispatch("createSchema").then(() => {
        this.$store.commit("setSnack", {
          "message": this.$t("schema.builder.success-message", { "schema-name": this.$store.state.schemaBuilder.name }),
          "color": "success"
        })
        this.$store.commit("flushSchemaBuilder")
        this.loading = false
        this.$router.push({ name: 'schema-list' })
      }).catch(error => {
        let status = error.response.status
        if (String(status).charAt(0) === "5") {
          this.$store.commit("setSnack", {
            "message": this.$t("schema.builder.server-error-message"),
            "color": "error"
          })
        } else if(status === 400) {
          this.$store.commit("setSnack", {
            "message": this.$t("schema.builder.bad-request-message"),
            "color": "warning"
          })
        }
        this.loading = false
      })
    },
    onBuilder() {
      if(this.$store.state.schemaBuilder.id !== 'undefined' && Number.isInteger(this.$store.state.schemaBuilder.id)) {
        this.$store.commit("flushSchemaBuilder")
      }
    },
    onUpdate() {
      this.loading = true
      this.$store.commit("flushSchemaBuilder")
      http.get('schema/' + this.$route.params.schemaId).then(({ data }) => {
        data.edit = true
        this.$store.commit("setSchemaBuilder", data)
        this.loading = false
      }).catch(({ response }) => {
        if(response.status === 404) {
          this.$router.push({ name: "not-found" })
        }
      })
    }
  },
  created() {
    if(this.isNew) {
      this.onBuilder()
    } else {
      this.onUpdate()
    }
  },
  watch: {
    '$route' () {
      if(this.isNew) {
        this.onBuilder()
      } else {
        this.onUpdate()
      }
    }
  }
}
</script>

<style>
#inspire {
  width: 80%;
  margin: 10px auto;
}
.tab-step-button-divider {
  margin: 14px auto 8px;
}
</style>
